import { MutationTree } from 'vuex'
import SocialLoginState from '../types/SocialLoginState'

const mutations: MutationTree<SocialLoginState> = {}

export default mutations
